import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import bday_boy from "../../assets/images/bday_boy_dp.jpg";
import birthday_card from "../../assets/images/birthday_card.png";
import upcoming_card from "../../assets/images/upcoming_card.png";
import boy_vector from "../../assets/images/boy_vector.jpg";
import { requestAllUserDetails } from "../../appRedux/actions/User";
import { getAllUser } from "../../appRedux/selectors/User";

const Birthday_modal = () => {
  const Users = useSelector(getAllUser);
  const dispatch = useDispatch();

  const today = new Date();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "-" + mm;

  let dateArray = [];
  for (let i = 1; i <= 7; i++) {
    const currDate = new Date();
    currDate.setDate(currDate.getDate() + i);
    let mm = currDate.getMonth() + 1; // Months start at 0!
    let dd = currDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    dateArray.push(`${dd}-${mm}`);
  }

  const todayBirthdateFetch = useMemo(() => {
    if (Users && Users.length) {
      const todaydatafind =
        Users &&
        Users.filter((data) => data?.birthdate.slice(0, 5) === formattedToday);
      return todaydatafind;
    }
    return "";
  }, [Users]);

  const upcomingBirthdateFetch = useMemo(() => {
    if (Users && Users.length) {
      var filtered = [];

      for (var arr in Users) {
        for (var filter in dateArray) {
          if (Users[arr].birthdate.slice(0, 5) == dateArray[filter]) {
            filtered.push(Users[arr]);
          }
        }
      }
      return filtered;
    }
    return "";
  }, [Users]);

  //Fetch User Details
  useEffect(() => {
    dispatch(requestAllUserDetails({ q: "" }));
  }, []);

  return (
    <EdayModalStyle>
      <div className="today-title">Today's Birthdays 🎂</div>
      {todayBirthdateFetch && todayBirthdateFetch.length ? (
        todayBirthdateFetch.map((data) => (
          <div className="today-bday-card">
            <div className="flex card-left">
              <img src={bday_boy} alt="dp" className="dpimage" />
              <div className="name-phone-section">
                <div className="name">{data?.user_name}</div>
                <div className="phone">{data?.mobile}</div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="no-found">No data found</div>
      )}

      <div className="today-title mt10">Upcoming's Birthdays 🥳</div>
      {upcomingBirthdateFetch && upcomingBirthdateFetch.length ? (
        upcomingBirthdateFetch.map((data) => (
          <div className="today-bday-card upcoming-card">
            <div className="flex card-left">
              <img src={boy_vector} alt="dp" className="dpimage2" />
              <div className="flex card-2">
                <div className="name-phone-section2">
                  <div className="name2">{data?.user_name}</div>
                  <div className="phone">{data?.mobile}</div>
                </div>
                <div className="date">{data?.birthdate}</div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="no-found">No data found</div>
      )}
    </EdayModalStyle>
  );
};

const EdayModalStyle = styled.div`
  font-family: "Cabin", sans-serif;
  .flex {
    display: flex;
  }
  .card-left {
    margin-left: 100px;
    align-self: center;
    margin-top: 6px;
    align-self: center;
  }
  .today-title {
    font-weight: 600;
    font-size: 16px;
    color: #000;
  }
  .today-bday-card {
    display: flex;
    justify-content: space-between;
    background-image: url(${birthday_card});
    border-radius: 10px;
    padding: 15px;
    margin-top: 15px;
    background-size: 454px;
    height: 118px;
    background-position-x: 4px;
    background-position-y: -54px;
    background-repeat: no-repeat;
  }
  .upcoming-card {
    background-image: url(${upcoming_card});
    background-position-y: -29px;
  }
  .dpimage {
    height: 55px;
    border-radius: 50%;
    align-self: center;
  }
  .dpimage2 {
    margin-left: 10px;
    height: 42px;
    border-radius: 50%;
    align-self: center;
  }
  .name-phone-section {
    font-size: 15px;
    color: #203c72;
    padding-left: 12px;
    align-self: center;
    width: 165px;
  }
  .name-phone-section2 {
    font-size: 12px;
    color: #203c72;
    padding-left: 12px;
    align-self: center;
    width: 165px;
  }
  .name {
    font-weight: 900;
    font-size: 20px;
  }
  .name2 {
    font-weight: 900;
    font-size: 16px;
  }
  .date {
    font-size: 12px;
    width: 82px;
  }
  .card-2 {
    width: 193px;
  }
  .cake-image {
    height: 60px;
  }
  .mt10 {
    margin-top: 20px;
  }
  .no-found {
    text-align-last: center;
    padding-top: 25px;
  }
  @media screen and (max-width: 520px) {
    .ant-modal-body {
      padding: 10px;
    }
    .today-bday-card {
      background-size: 354px;
      height: 98px;
      background-position-x: -9px;
      background-position-y: -39px;
    }
    .card-left {
      margin-left: 65px;
      position: relative;
    }
    .upcoming-card {
      background-size: 364px;
      height: 91px;
      background-position-x: -20px;
      background-position-y: -24px;
    }
    .date {
      position: absolute;
      font-size: 11px;
      width: 82px;
      bottom: -10px;
      left: 61px;
    }
  }
`;

export default Birthday_modal;
